import { FilterOption } from 'components/featured/Deals/types';
import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';

export const useDealTypesOptions = () => {
  const [dealTypes, setDealTypes] = useState<FilterOption[]>([]);

  useEffect(() => {
    const fetchPipelines = async () => {
      try {
        const data = await DealsService.getDealTypes();
        const formattedKeys = data.data
          .map((item: any) => ({
            Name: item.dealTypeKey || '',
            label: item.dealTypeName || '',
            Id: item.dealTypeId || '',
          }))
          .filter((item: any) => item.Name && item.Id);
        setDealTypes(formattedKeys);
      } catch (error) {
        console.error('Failed to fetch pipeline types', error);
        setDealTypes([]);
      }
    };

    fetchPipelines();
  }, []);

  return {
    dealTypes,
  };
};
